import type { BracketShape } from '../types'

/**
 * Матч нельзя менять/снять пик, если в любом downstream-матче (по source_match_id)
 * уже есть user_pick_team_id — иначе ломается каскад прогнозов.
 */
export const isBracketMatchLockedByDownstreamPicks = (
  bracket: BracketShape,
  matchId: number
): boolean => {
  for (const match of bracket.matches) {
    const dependsOnSource = match.slots.some(
      slot => slot.source_match_id === matchId
    )
    if (!dependsOnSource) continue

    if (match.user_pick_team_id !== null) return true
    if (isBracketMatchLockedByDownstreamPicks(bracket, match.id)) return true
  }

  return false
}
